import client from './client';
export const getAutomationEngine = () => client.get('/v1/automations/engine/');

export const listAutomations = () => client.get('/v1/automations/');
export const createAutomation = (data) => client.post('/v1/automations/', data);
export const getAutomation = (id) => client.get(`/v1/automations/${id}/`);
export const updateAutomation = (id, data) => client.put(`/v1/automations/${id}/`, data);
export const deleteAutomation = (id) => client.delete(`/v1/automations/${id}/`);
export const getAutomationLogs = (id) => client.get(`/v1/automations/${id}/logs/`);
